module.exports = __webpack_public_path__ + "static/assets/17379c73126b2f6d9ba52eef62c946d4.png";